import React from 'react'

const Gaps = ({ level = 1 }) => {
  return <div style={{ padding: level * 8 }} />
}

export default Gaps
